// eslint-disable-next-line no-undef
IntlPolyfill.__addLocaleData({
  locale: 'fr',
  date: {
    ca: [
      'gregory',
      'buddhist',
      'chinese',
      'coptic',
      'dangi',
      'ethioaa',
      'ethiopic',
      'generic',
      'hebrew',
      'indian',
      'islamic',
      'islamicc',
      'japanese',
      'persian',
      'roc',
    ],
    hourNo0: true,
    hour12: false,
    formats: {
      short: '{1} {0}',
      medium: "{1} 'Ã ' {0}",
      full: "{1} 'Ã ' {0}",
      long: "{1} 'Ã ' {0}",
      availableFormats: {
        d: 'd',
        E: 'E',
        Ed: 'E d',
        Ehm: 'E h:mm a',
        EHm: 'E HH:mm',
        Ehms: 'E h:mm:ss a',
        EHms: 'E HH:mm:ss',
        Gy: 'y G',
        GyMMM: 'MMM y G',
        GyMMMd: 'd MMM y G',
        GyMMMEd: 'E d MMM y G',
        h: 'h a',
        H: "HH 'h'",
        hm: 'h:mm a',
        Hm: 'HH:mm',
        hms: 'h:mm:ss a',
        Hms: 'HH:mm:ss',
        hmsv: 'h:mm:ss a v',
        Hmsv: 'HH:mm:ss v',
        hmv: 'h:mm a v',
        Hmv: 'HH:mm v',
        M: 'L',
        Md: 'dd/MM',
        MEd: 'E dd/MM',
        MMM: 'LLL',
        MMMd: 'd MMM',
        MMMEd: 'E d MMM',
        MMMMd: 'd MMMM',
        ms: 'mm:ss',
        y: 'y',
        yM: 'MM/y',
        yMd: 'dd/MM/y',
        yMEd: 'E dd/MM/y',
        yMMM: 'MMM y',
        yMMMd: 'd MMM y',
        yMMMEd: 'E d MMM y',
        yMMMM: 'MMMM y',
        yQQQ: 'QQQ y',
        yQQQQ: 'QQQQ y',
      },
      dateFormats: {
        yMMMMEEEEd: 'EEEE d MMMM y',
        yMMMMd: 'd MMMM y',
        yMMMd: 'd MMM y',
        yMd: 'dd/MM/y',
      },
      timeFormats: {
        hmmsszzzz: 'HH:mm:ss zzzz',
        hmsz: 'HH:mm:ss z',
        hms: 'HH:mm:ss',
        hm: 'HH:mm',
      },
    },
    calendars: {
      buddhist: {
        months: {
          narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
          short: [
            'janv.',
            'fÃ©vr.',
            'mars',
            'avr.',
            'mai',
            'juin',
            'juil.',
            'aoÃ»t',
            'sept.',
            'oct.',
            'nov.',
            'dÃ©c.',
          ],
          long: [
            'janvier',
            'fÃ©vrier',
            'mars',
            'avril',
            'mai',
            'juin',
            'juillet',
            'aoÃ»t',
            'septembre',
            'octobre',
            'novembre',
            'dÃ©cembre',
          ],
        },
        days: {
          narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
          short: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
          long: [
            'dimanche',
            'lundi',
            'mardi',
            'mercredi',
            'jeudi',
            'vendredi',
            'samedi',
          ],
        },
        eras: {
          narrow: ['E.B.'],
          short: ['Ã¨re b.'],
          long: ['Ã¨re bouddhiste'],
        },
        dayPeriods: { am: 'AM', pm: 'PM' },
      },
      chinese: {
        months: {
          narrow: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
          ],
          short: [
            '1yuÃ¨',
            '2yuÃ¨',
            '3yuÃ¨',
            '4yuÃ¨',
            '5yuÃ¨',
            '6yuÃ¨',
            '7yuÃ¨',
            '8yuÃ¨',
            '9yuÃ¨',
            '10yuÃ¨',
            '11yuÃ¨',
            '12yuÃ¨',
          ],
          long: [
            'zhÄ“ngyuÃ¨',
            'Ã¨ryuÃ¨',
            'sÄnyuÃ¨',
            'sÃ¬yuÃ¨',
            'wÇ”yuÃ¨',
            'liÃ¹yuÃ¨',
            'qÄ«yuÃ¨',
            'bÄyuÃ¨',
            'jiÇ”yuÃ¨',
            'shÃ­yuÃ¨',
            'shÃ­yÄ«yuÃ¨',
            'shÃ­â€™Ã¨ryuÃ¨',
          ],
        },
        days: {
          narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
          short: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
          long: [
            'dimanche',
            'lundi',
            'mardi',
            'mercredi',
            'jeudi',
            'vendredi',
            'samedi',
          ],
        },
        dayPeriods: { am: 'AM', pm: 'PM' },
      },
      coptic: {
        months: {
          narrow: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
            '13',
          ],
          short: [
            'Tout',
            'Baba',
            'Hator',
            'Kiahk',
            'Toba',
            'Amshir',
            'Baramhat',
            'Baramouda',
            'Bashans',
            'Paona',
            'Epep',
            'Mesra',
            'Nasie',
          ],
          long: [
            'Tout',
            'Baba',
            'Hator',
            'Kiahk',
            'Toba',
            'Amshir',
            'Baramhat',
            'Baramouda',
            'Bashans',
            'Paona',
            'Epep',
            'Mesra',
            'Nasie',
          ],
        },
        days: {
          narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
          short: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
          long: [
            'dimanche',
            'lundi',
            'mardi',
            'mercredi',
            'jeudi',
            'vendredi',
            'samedi',
          ],
        },
        eras: {
          narrow: ['ERA0', 'ERA1'],
          short: ['ERA0', 'ERA1'],
          long: ['ERA0', 'ERA1'],
        },
        dayPeriods: { am: 'AM', pm: 'PM' },
      },
      dangi: {
        months: {
          narrow: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
          ],
          short: [
            '1yuÃ¨',
            '2yuÃ¨',
            '3yuÃ¨',
            '4yuÃ¨',
            '5yuÃ¨',
            '6yuÃ¨',
            '7yuÃ¨',
            '8yuÃ¨',
            '9yuÃ¨',
            '10yuÃ¨',
            '11yuÃ¨',
            '12yuÃ¨',
          ],
          long: [
            'zhÄ“ngyuÃ¨',
            'Ã¨ryuÃ¨',
            'sÄnyuÃ¨',
            'sÃ¬yuÃ¨',
            'wÇ”yuÃ¨',
            'liÃ¹yuÃ¨',
            'qÄ«yuÃ¨',
            'bÄyuÃ¨',
            'jiÇ”yuÃ¨',
            'shÃ­yuÃ¨',
            'shÃ­yÄ«yuÃ¨',
            'shÃ­â€™Ã¨ryuÃ¨',
          ],
        },
        days: {
          narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
          short: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
          long: [
            'dimanche',
            'lundi',
            'mardi',
            'mercredi',
            'jeudi',
            'vendredi',
            'samedi',
          ],
        },
        dayPeriods: { am: 'AM', pm: 'PM' },
      },
      ethiopic: {
        months: {
          narrow: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
            '13',
          ],
          short: [
            'Meskerem',
            'Tekemt',
            'Hedar',
            'Tahsas',
            'Ter',
            'Yekatit',
            'Megabit',
            'Miazia',
            'Genbot',
            'Sene',
            'Hamle',
            'Nehasse',
            'Pagumen',
          ],
          long: [
            'Meskerem',
            'Tekemt',
            'Hedar',
            'Tahsas',
            'Ter',
            'Yekatit',
            'Megabit',
            'Miazia',
            'Genbot',
            'Sene',
            'Hamle',
            'Nehasse',
            'Pagumen',
          ],
        },
        days: {
          narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
          short: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
          long: [
            'dimanche',
            'lundi',
            'mardi',
            'mercredi',
            'jeudi',
            'vendredi',
            'samedi',
          ],
        },
        eras: {
          narrow: ['ERA0', 'ERA1'],
          short: ['ERA0', 'ERA1'],
          long: ['ERA0', 'ERA1'],
        },
        dayPeriods: { am: 'AM', pm: 'PM' },
      },
      ethioaa: {
        months: {
          narrow: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
            '13',
          ],
          short: [
            'Meskerem',
            'Tekemt',
            'Hedar',
            'Tahsas',
            'Ter',
            'Yekatit',
            'Megabit',
            'Miazia',
            'Genbot',
            'Sene',
            'Hamle',
            'Nehasse',
            'Pagumen',
          ],
          long: [
            'Meskerem',
            'Tekemt',
            'Hedar',
            'Tahsas',
            'Ter',
            'Yekatit',
            'Megabit',
            'Miazia',
            'Genbot',
            'Sene',
            'Hamle',
            'Nehasse',
            'Pagumen',
          ],
        },
        days: {
          narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
          short: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
          long: [
            'dimanche',
            'lundi',
            'mardi',
            'mercredi',
            'jeudi',
            'vendredi',
            'samedi',
          ],
        },
        eras: { narrow: ['ERA0'], short: ['ERA0'], long: ['ERA0'] },
        dayPeriods: { am: 'AM', pm: 'PM' },
      },
      generic: {
        months: {
          narrow: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
          ],
          short: [
            'M01',
            'M02',
            'M03',
            'M04',
            'M05',
            'M06',
            'M07',
            'M08',
            'M09',
            'M10',
            'M11',
            'M12',
          ],
          long: [
            'M01',
            'M02',
            'M03',
            'M04',
            'M05',
            'M06',
            'M07',
            'M08',
            'M09',
            'M10',
            'M11',
            'M12',
          ],
        },
        days: {
          narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
          short: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
          long: [
            'dimanche',
            'lundi',
            'mardi',
            'mercredi',
            'jeudi',
            'vendredi',
            'samedi',
          ],
        },
        eras: {
          narrow: ['ERA0', 'ERA1'],
          short: ['ERA0', 'ERA1'],
          long: ['ERA0', 'ERA1'],
        },
        dayPeriods: { am: 'AM', pm: 'PM' },
      },
      gregory: {
        months: {
          narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
          short: [
            'janv.',
            'fÃ©vr.',
            'mars',
            'avr.',
            'mai',
            'juin',
            'juil.',
            'aoÃ»t',
            'sept.',
            'oct.',
            'nov.',
            'dÃ©c.',
          ],
          long: [
            'janvier',
            'fÃ©vrier',
            'mars',
            'avril',
            'mai',
            'juin',
            'juillet',
            'aoÃ»t',
            'septembre',
            'octobre',
            'novembre',
            'dÃ©cembre',
          ],
        },
        days: {
          narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
          short: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
          long: [
            'dimanche',
            'lundi',
            'mardi',
            'mercredi',
            'jeudi',
            'vendredi',
            'samedi',
          ],
        },
        eras: {
          narrow: ['av. J.-C.', 'ap. J.-C.', 'AEC', 'EC'],
          short: ['av. J.-C.', 'ap. J.-C.', 'AEC', 'EC'],
          long: [
            'avant JÃ©sus-Christ',
            'aprÃ¨s JÃ©sus-Christ',
            'avant lâ€™Ã¨re commune',
            'de lâ€™Ã¨re commune',
          ],
        },
        dayPeriods: { am: 'AM', pm: 'PM' },
      },
      hebrew: {
        months: {
          narrow: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
            '13',
            '7',
          ],
          short: [
            'Tisseri',
            'Hesvan',
            'Kislev',
            'TÃ©beth',
            'SchÃ©bat',
            'Adar I',
            'Adar',
            'Nissan',
            'Iyar',
            'Sivan',
            'Tamouz',
            'Ab',
            'Elloul',
            'Adar II',
          ],
          long: [
            'Tisseri',
            'Hesvan',
            'Kislev',
            'TÃ©beth',
            'SchÃ©bat',
            'Adar I',
            'Adar',
            'Nissan',
            'Iyar',
            'Sivan',
            'Tamouz',
            'Ab',
            'Elloul',
            'Adar II',
          ],
        },
        days: {
          narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
          short: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
          long: [
            'dimanche',
            'lundi',
            'mardi',
            'mercredi',
            'jeudi',
            'vendredi',
            'samedi',
          ],
        },
        eras: { narrow: ['AM'], short: ['AM'], long: ['AM'] },
        dayPeriods: { am: 'AM', pm: 'PM' },
      },
      indian: {
        months: {
          narrow: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
          ],
          short: [
            'Chaitra',
            'Vaisakha',
            'Jyaistha',
            'Asadha',
            'Sravana',
            'Bhadra',
            'Asvina',
            'Kartika',
            'Agrahayana',
            'Pausa',
            'Magha',
            'Phalguna',
          ],
          long: [
            'Chaitra',
            'Vaisakha',
            'Jyaistha',
            'Asadha',
            'Sravana',
            'Bhadra',
            'Asvina',
            'Kartika',
            'Agrahayana',
            'Pausa',
            'Magha',
            'Phalguna',
          ],
        },
        days: {
          narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
          short: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
          long: [
            'dimanche',
            'lundi',
            'mardi',
            'mercredi',
            'jeudi',
            'vendredi',
            'samedi',
          ],
        },
        eras: { narrow: ['Saka'], short: ['Saka'], long: ['Saka'] },
        dayPeriods: { am: 'AM', pm: 'PM' },
      },
      islamic: {
        months: {
          narrow: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
          ],
          short: [
            'mouh.',
            'saf.',
            'rab. aw.',
            'rab. th.',
            'joum. oul.',
            'joum. tha.',
            'raj.',
            'chaa.',
            'ram.',
            'chaw.',
            'dhou. q.',
            'dhou. h.',
          ],
          long: [
            'mouharram',
            'safar',
            'rabia al awal',
            'rabia ath-thani',
            'joumada al oula',
            'joumada ath-thania',
            'rajab',
            'chaabane',
            'ramadan',
            'chawwal',
            'dhou al qi`da',
            'dhou al-hijja',
          ],
        },
        days: {
          narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
          short: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
          long: [
            'dimanche',
            'lundi',
            'mardi',
            'mercredi',
            'jeudi',
            'vendredi',
            'samedi',
          ],
        },
        eras: { narrow: ['AH'], short: ['AH'], long: ['AH'] },
        dayPeriods: { am: 'AM', pm: 'PM' },
      },
      islamicc: {
        months: {
          narrow: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
          ],
          short: [
            'mouh.',
            'saf.',
            'rab. aw.',
            'rab. th.',
            'joum. oul.',
            'joum. tha.',
            'raj.',
            'chaa.',
            'ram.',
            'chaw.',
            'dhou. q.',
            'dhou. h.',
          ],
          long: [
            'mouharram',
            'safar',
            'rabia al awal',
            'rabia ath-thani',
            'joumada al oula',
            'joumada ath-thania',
            'rajab',
            'chaabane',
            'ramadan',
            'chawwal',
            'dhou al qi`da',
            'dhou al-hijja',
          ],
        },
        days: {
          narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
          short: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
          long: [
            'dimanche',
            'lundi',
            'mardi',
            'mercredi',
            'jeudi',
            'vendredi',
            'samedi',
          ],
        },
        eras: { narrow: ['AH'], short: ['AH'], long: ['AH'] },
        dayPeriods: { am: 'AM', pm: 'PM' },
      },
      japanese: {
        months: {
          narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
          short: [
            'janv.',
            'fÃ©vr.',
            'mars',
            'avr.',
            'mai',
            'juin',
            'juil.',
            'aoÃ»t',
            'sept.',
            'oct.',
            'nov.',
            'dÃ©c.',
          ],
          long: [
            'janvier',
            'fÃ©vrier',
            'mars',
            'avril',
            'mai',
            'juin',
            'juillet',
            'aoÃ»t',
            'septembre',
            'octobre',
            'novembre',
            'dÃ©cembre',
          ],
        },
        days: {
          narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
          short: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
          long: [
            'dimanche',
            'lundi',
            'mardi',
            'mercredi',
            'jeudi',
            'vendredi',
            'samedi',
          ],
        },
        eras: {
          narrow: [
            'Taika (645â€“650)',
            'Hakuchi (650â€“671)',
            'HakuhÅ (672â€“686)',
            'ShuchÅ (686â€“701)',
            'TaihÅ (701â€“704)',
            'Keiun (704â€“708)',
            'WadÅ (708â€“715)',
            'Reiki (715â€“717)',
            'YÅrÅ (717â€“724)',
            'Jinki (724â€“729)',
            'TenpyÅ (729â€“749)',
            'TenpyÅ-kampÅ (749-749)',
            'TenpyÅ-shÅhÅ (749-757)',
            'TenpyÅ-hÅji (757-765)',
            'TenpyÅ-jingo (765-767)',
            'Jingo-keiun (767-770)',
            'HÅki (770â€“780)',
            'Ten-Å (781-782)',
            'Enryaku (782â€“806)',
            'DaidÅ (806â€“810)',
            'KÅnin (810â€“824)',
            'TenchÅ (824â€“834)',
            'JÅwa (834â€“848)',
            'KajÅ (848â€“851)',
            'Ninju (851â€“854)',
            'SaikÅ (854â€“857)',
            'Ten-an (857-859)',
            'JÅgan (859â€“877)',
            'GangyÅ (877â€“885)',
            'Ninna (885â€“889)',
            'KanpyÅ (889â€“898)',
            'ShÅtai (898â€“901)',
            'Engi (901â€“923)',
            'EnchÅ (923â€“931)',
            'JÅhei (931â€“938)',
            'TengyÅ (938â€“947)',
            'Tenryaku (947â€“957)',
            'Tentoku (957â€“961)',
            'ÅŒwa (961â€“964)',
            'KÅhÅ (964â€“968)',
            'Anna (968â€“970)',
            'Tenroku (970â€“973)',
            'Tenâ€™en (973â€“976)',
            'JÅgen (976â€“978)',
            'Tengen (978â€“983)',
            'Eikan (983â€“985)',
            'Kanna (985â€“987)',
            'Eien (987â€“989)',
            'Eiso (989â€“990)',
            'ShÅryaku (990â€“995)',
            'ChÅtoku (995â€“999)',
            'ChÅhÅ (999â€“1004)',
            'KankÅ (1004â€“1012)',
            'ChÅwa (1012â€“1017)',
            'Kannin (1017â€“1021)',
            'Jian (1021â€“1024)',
            'Manju (1024â€“1028)',
            'ChÅgen (1028â€“1037)',
            'ChÅryaku (1037â€“1040)',
            'ChÅkyÅ« (1040â€“1044)',
            'Kantoku (1044â€“1046)',
            'EishÅ (1046â€“1053)',
            'Tengi (1053â€“1058)',
            'KÅhei (1058â€“1065)',
            'Jiryaku (1065â€“1069)',
            'EnkyÅ« (1069â€“1074)',
            'ShÅho (1074â€“1077)',
            'ShÅryaku (1077â€“1081)',
            'EihÅ (1081â€“1084)',
            'ÅŒtoku (1084â€“1087)',
            'Kanji (1087â€“1094)',
            'KahÅ (1094â€“1096)',
            'EichÅ (1096â€“1097)',
            'JÅtoku (1097â€“1099)',
            'KÅwa (1099â€“1104)',
            'ChÅji (1104â€“1106)',
            'KashÅ (1106â€“1108)',
            'Tennin (1108â€“1110)',
            'Ten-ei (1110-1113)',
            'EikyÅ« (1113â€“1118)',
            'Genâ€™ei (1118â€“1120)',
            'HÅan (1120â€“1124)',
            'Tenji (1124â€“1126)',
            'Daiji (1126â€“1131)',
            'TenshÅ (1131â€“1132)',
            'ChÅshÅ (1132â€“1135)',
            'HÅen (1135â€“1141)',
            'Eiji (1141â€“1142)',
            'KÅji (1142â€“1144)',
            'Tenâ€™yÅ (1144â€“1145)',
            'KyÅ«an (1145â€“1151)',
            'Ninpei (1151â€“1154)',
            'KyÅ«ju (1154â€“1156)',
            'HÅgen (1156â€“1159)',
            'Heiji (1159â€“1160)',
            'Eiryaku (1160â€“1161)',
            'ÅŒho (1161â€“1163)',
            'ChÅkan (1163â€“1165)',
            'Eiman (1165â€“1166)',
            'Ninâ€™an (1166â€“1169)',
            'KaÅ (1169â€“1171)',
            'ShÅan (1171â€“1175)',
            'Angen (1175â€“1177)',
            'JishÅ (1177â€“1181)',
            'YÅwa (1181â€“1182)',
            'Juei (1182â€“1184)',
            'Genryaku (1184â€“1185)',
            'Bunji (1185â€“1190)',
            'KenkyÅ« (1190â€“1199)',
            'ShÅji (1199â€“1201)',
            'Kennin (1201â€“1204)',
            'GenkyÅ« (1204â€“1206)',
            'Kenâ€™ei (1206â€“1207)',
            'JÅgen (1207â€“1211)',
            'Kenryaku (1211â€“1213)',
            'KenpÅ (1213â€“1219)',
            'JÅkyÅ« (1219â€“1222)',
            'JÅÅ (1222â€“1224)',
            'Gennin (1224â€“1225)',
            'Karoku (1225â€“1227)',
            'Antei (1227â€“1229)',
            'Kanki (1229â€“1232)',
            'JÅei (1232â€“1233)',
            'Tenpuku (1233â€“1234)',
            'Bunryaku (1234â€“1235)',
            'Katei (1235â€“1238)',
            'Ryakunin (1238â€“1239)',
            'Enâ€™Å (1239â€“1240)',
            'Ninji (1240â€“1243)',
            'Kangen (1243â€“1247)',
            'HÅji (1247â€“1249)',
            'KenchÅ (1249â€“1256)',
            'KÅgen (1256â€“1257)',
            'ShÅka (1257â€“1259)',
            'ShÅgen (1259â€“1260)',
            'Bunâ€™Å (1260â€“1261)',
            'KÅchÅ (1261â€“1264)',
            'Bunâ€™ei (1264â€“1275)',
            'Kenji (1275â€“1278)',
            'KÅan (1278â€“1288)',
            'ShÅÅ (1288â€“1293)',
            'Einin (1293â€“1299)',
            'ShÅan (1299â€“1302)',
            'Kengen (1302â€“1303)',
            'Kagen (1303â€“1306)',
            'Tokuji (1306â€“1308)',
            'EnkyÅ (1308â€“1311)',
            'ÅŒchÅ (1311â€“1312)',
            'ShÅwa (1312â€“1317)',
            'BunpÅ (1317â€“1319)',
            'GenÅ (1319â€“1321)',
            'GenkÅ (1321â€“1324)',
            'ShÅchÅ« (1324â€“1326)',
            'Karyaku (1326â€“1329)',
            'Gentoku (1329â€“1331)',
            'GenkÅ (1331â€“1334)',
            'Kenmu (1334â€“1336)',
            'Engen (1336â€“1340)',
            'KÅkoku (1340â€“1346)',
            'ShÅhei (1346â€“1370)',
            'Kentoku (1370â€“1372)',
            'BunchÅ« (1372â€“1375)',
            'Tenju (1375â€“1379)',
            'KÅryaku (1379â€“1381)',
            'KÅwa (1381â€“1384)',
            'GenchÅ« (1384â€“1392)',
            'Meitoku (1384â€“1387)',
            'Kakei (1387â€“1389)',
            'KÅÅ (1389â€“1390)',
            'Meitoku (1390â€“1394)',
            'ÅŒei (1394â€“1428)',
            'ShÅchÅ (1428â€“1429)',
            'EikyÅ (1429â€“1441)',
            'Kakitsu (1441â€“1444)',
            'Bunâ€™an (1444â€“1449)',
            'HÅtoku (1449â€“1452)',
            'KyÅtoku (1452â€“1455)',
            'KÅshÅ (1455â€“1457)',
            'ChÅroku (1457â€“1460)',
            'KanshÅ (1460â€“1466)',
            'BunshÅ (1466â€“1467)',
            'ÅŒnin (1467â€“1469)',
            'Bunmei (1469â€“1487)',
            'ChÅkyÅ (1487â€“1489)',
            'Entoku (1489â€“1492)',
            'MeiÅ (1492â€“1501)',
            'Bunki (1501â€“1504)',
            'EishÅ (1504â€“1521)',
            'Taiei (1521â€“1528)',
            'KyÅroku (1528â€“1532)',
            'Tenbun (1532â€“1555)',
            'KÅji (1555â€“1558)',
            'Eiroku (1558â€“1570)',
            'Genki (1570â€“1573)',
            'TenshÅ (1573â€“1592)',
            'Bunroku (1592â€“1596)',
            'KeichÅ (1596â€“1615)',
            'Genna (1615â€“1624)',
            'Kanâ€™ei (1624â€“1644)',
            'ShÅho (1644â€“1648)',
            'Keian (1648â€“1652)',
            'JÅÅ (1652â€“1655)',
            'Meireki (1655â€“1658)',
            'Manji (1658â€“1661)',
            'Kanbun (1661â€“1673)',
            'EnpÅ (1673â€“1681)',
            'Tenna (1681â€“1684)',
            'JÅkyÅ (1684â€“1688)',
            'Genroku (1688â€“1704)',
            'HÅei (1704â€“1711)',
            'ShÅtoku (1711â€“1716)',
            'KyÅhÅ (1716â€“1736)',
            'Genbun (1736â€“1741)',
            'KanpÅ (1741â€“1744)',
            'EnkyÅ (1744â€“1748)',
            'Kanâ€™en (1748â€“1751)',
            'HÅreki (1751â€“1764)',
            'Meiwa (1764â€“1772)',
            'Anâ€™ei (1772â€“1781)',
            'Tenmei (1781â€“1789)',
            'Kansei (1789â€“1801)',
            'KyÅwa (1801â€“1804)',
            'Bunka (1804â€“1818)',
            'Bunsei (1818â€“1830)',
            'TenpÅ (1830â€“1844)',
            'KÅka (1844â€“1848)',
            'Kaei (1848â€“1854)',
            'Ansei (1854â€“1860)',
            'Manâ€™en (1860â€“1861)',
            'BunkyÅ« (1861â€“1864)',
            'Genji (1864â€“1865)',
            'KeiÅ (1865â€“1868)',
            'M',
            'T',
            'S',
            'H',
          ],
          short: [
            'Taika (645â€“650)',
            'Hakuchi (650â€“671)',
            'HakuhÅ (672â€“686)',
            'ShuchÅ (686â€“701)',
            'TaihÅ (701â€“704)',
            'Keiun (704â€“708)',
            'WadÅ (708â€“715)',
            'Reiki (715â€“717)',
            'YÅrÅ (717â€“724)',
            'Jinki (724â€“729)',
            'TenpyÅ (729â€“749)',
            'TenpyÅ-kampÅ (749-749)',
            'TenpyÅ-shÅhÅ (749-757)',
            'TenpyÅ-hÅji (757-765)',
            'TenpyÅ-jingo (765-767)',
            'Jingo-keiun (767-770)',
            'HÅki (770â€“780)',
            'Ten-Å (781-782)',
            'Enryaku (782â€“806)',
            'DaidÅ (806â€“810)',
            'KÅnin (810â€“824)',
            'TenchÅ (824â€“834)',
            'JÅwa (834â€“848)',
            'KajÅ (848â€“851)',
            'Ninju (851â€“854)',
            'SaikÅ (854â€“857)',
            'Ten-an (857-859)',
            'JÅgan (859â€“877)',
            'GangyÅ (877â€“885)',
            'Ninna (885â€“889)',
            'KanpyÅ (889â€“898)',
            'ShÅtai (898â€“901)',
            'Engi (901â€“923)',
            'EnchÅ (923â€“931)',
            'JÅhei (931â€“938)',
            'TengyÅ (938â€“947)',
            'Tenryaku (947â€“957)',
            'Tentoku (957â€“961)',
            'ÅŒwa (961â€“964)',
            'KÅhÅ (964â€“968)',
            'Anna (968â€“970)',
            'Tenroku (970â€“973)',
            'Tenâ€™en (973â€“976)',
            'JÅgen (976â€“978)',
            'Tengen (978â€“983)',
            'Eikan (983â€“985)',
            'Kanna (985â€“987)',
            'Eien (987â€“989)',
            'Eiso (989â€“990)',
            'ShÅryaku (990â€“995)',
            'ChÅtoku (995â€“999)',
            'ChÅhÅ (999â€“1004)',
            'KankÅ (1004â€“1012)',
            'ChÅwa (1012â€“1017)',
            'Kannin (1017â€“1021)',
            'Jian (1021â€“1024)',
            'Manju (1024â€“1028)',
            'ChÅgen (1028â€“1037)',
            'ChÅryaku (1037â€“1040)',
            'ChÅkyÅ« (1040â€“1044)',
            'Kantoku (1044â€“1046)',
            'EishÅ (1046â€“1053)',
            'Tengi (1053â€“1058)',
            'KÅhei (1058â€“1065)',
            'Jiryaku (1065â€“1069)',
            'EnkyÅ« (1069â€“1074)',
            'ShÅho (1074â€“1077)',
            'ShÅryaku (1077â€“1081)',
            'EihÅ (1081â€“1084)',
            'ÅŒtoku (1084â€“1087)',
            'Kanji (1087â€“1094)',
            'KahÅ (1094â€“1096)',
            'EichÅ (1096â€“1097)',
            'JÅtoku (1097â€“1099)',
            'KÅwa (1099â€“1104)',
            'ChÅji (1104â€“1106)',
            'KashÅ (1106â€“1108)',
            'Tennin (1108â€“1110)',
            'Ten-ei (1110-1113)',
            'EikyÅ« (1113â€“1118)',
            'Genâ€™ei (1118â€“1120)',
            'HÅan (1120â€“1124)',
            'Tenji (1124â€“1126)',
            'Daiji (1126â€“1131)',
            'TenshÅ (1131â€“1132)',
            'ChÅshÅ (1132â€“1135)',
            'HÅen (1135â€“1141)',
            'Eiji (1141â€“1142)',
            'KÅji (1142â€“1144)',
            'Tenâ€™yÅ (1144â€“1145)',
            'KyÅ«an (1145â€“1151)',
            'Ninpei (1151â€“1154)',
            'KyÅ«ju (1154â€“1156)',
            'HÅgen (1156â€“1159)',
            'Heiji (1159â€“1160)',
            'Eiryaku (1160â€“1161)',
            'ÅŒho (1161â€“1163)',
            'ChÅkan (1163â€“1165)',
            'Eiman (1165â€“1166)',
            'Ninâ€™an (1166â€“1169)',
            'KaÅ (1169â€“1171)',
            'ShÅan (1171â€“1175)',
            'Angen (1175â€“1177)',
            'JishÅ (1177â€“1181)',
            'YÅwa (1181â€“1182)',
            'Juei (1182â€“1184)',
            'Genryaku (1184â€“1185)',
            'Bunji (1185â€“1190)',
            'KenkyÅ« (1190â€“1199)',
            'ShÅji (1199â€“1201)',
            'Kennin (1201â€“1204)',
            'GenkyÅ« (1204â€“1206)',
            'Kenâ€™ei (1206â€“1207)',
            'JÅgen (1207â€“1211)',
            'Kenryaku (1211â€“1213)',
            'KenpÅ (1213â€“1219)',
            'JÅkyÅ« (1219â€“1222)',
            'JÅÅ (1222â€“1224)',
            'Gennin (1224â€“1225)',
            'Karoku (1225â€“1227)',
            'Antei (1227â€“1229)',
            'Kanki (1229â€“1232)',
            'JÅei (1232â€“1233)',
            'Tenpuku (1233â€“1234)',
            'Bunryaku (1234â€“1235)',
            'Katei (1235â€“1238)',
            'Ryakunin (1238â€“1239)',
            'Enâ€™Å (1239â€“1240)',
            'Ninji (1240â€“1243)',
            'Kangen (1243â€“1247)',
            'HÅji (1247â€“1249)',
            'KenchÅ (1249â€“1256)',
            'KÅgen (1256â€“1257)',
            'ShÅka (1257â€“1259)',
            'ShÅgen (1259â€“1260)',
            'Bunâ€™Å (1260â€“1261)',
            'KÅchÅ (1261â€“1264)',
            'Bunâ€™ei (1264â€“1275)',
            'Kenji (1275â€“1278)',
            'KÅan (1278â€“1288)',
            'ShÅÅ (1288â€“1293)',
            'Einin (1293â€“1299)',
            'ShÅan (1299â€“1302)',
            'Kengen (1302â€“1303)',
            'Kagen (1303â€“1306)',
            'Tokuji (1306â€“1308)',
            'EnkyÅ (1308â€“1311)',
            'ÅŒchÅ (1311â€“1312)',
            'ShÅwa (1312â€“1317)',
            'BunpÅ (1317â€“1319)',
            'GenÅ (1319â€“1321)',
            'GenkÅ (1321â€“1324)',
            'ShÅchÅ« (1324â€“1326)',
            'Karyaku (1326â€“1329)',
            'Gentoku (1329â€“1331)',
            'GenkÅ (1331â€“1334)',
            'Kenmu (1334â€“1336)',
            'Engen (1336â€“1340)',
            'KÅkoku (1340â€“1346)',
            'ShÅhei (1346â€“1370)',
            'Kentoku (1370â€“1372)',
            'BunchÅ« (1372â€“1375)',
            'Tenju (1375â€“1379)',
            'KÅryaku (1379â€“1381)',
            'KÅwa (1381â€“1384)',
            'GenchÅ« (1384â€“1392)',
            'Meitoku (1384â€“1387)',
            'Kakei (1387â€“1389)',
            'KÅÅ (1389â€“1390)',
            'Meitoku (1390â€“1394)',
            'ÅŒei (1394â€“1428)',
            'ShÅchÅ (1428â€“1429)',
            'EikyÅ (1429â€“1441)',
            'Kakitsu (1441â€“1444)',
            'Bunâ€™an (1444â€“1449)',
            'HÅtoku (1449â€“1452)',
            'KyÅtoku (1452â€“1455)',
            'KÅshÅ (1455â€“1457)',
            'ChÅroku (1457â€“1460)',
            'KanshÅ (1460â€“1466)',
            'BunshÅ (1466â€“1467)',
            'ÅŒnin (1467â€“1469)',
            'Bunmei (1469â€“1487)',
            'ChÅkyÅ (1487â€“1489)',
            'Entoku (1489â€“1492)',
            'MeiÅ (1492â€“1501)',
            'Bunki (1501â€“1504)',
            'EishÅ (1504â€“1521)',
            'Taiei (1521â€“1528)',
            'KyÅroku (1528â€“1532)',
            'Tenbun (1532â€“1555)',
            'KÅji (1555â€“1558)',
            'Eiroku (1558â€“1570)',
            'Genki (1570â€“1573)',
            'TenshÅ (1573â€“1592)',
            'Bunroku (1592â€“1596)',
            'KeichÅ (1596â€“1615)',
            'Genna (1615â€“1624)',
            'Kanâ€™ei (1624â€“1644)',
            'ShÅho (1644â€“1648)',
            'Keian (1648â€“1652)',
            'JÅÅ (1652â€“1655)',
            'Meireki (1655â€“1658)',
            'Manji (1658â€“1661)',
            'Kanbun (1661â€“1673)',
            'EnpÅ (1673â€“1681)',
            'Tenna (1681â€“1684)',
            'JÅkyÅ (1684â€“1688)',
            'Genroku (1688â€“1704)',
            'HÅei (1704â€“1711)',
            'ShÅtoku (1711â€“1716)',
            'KyÅhÅ (1716â€“1736)',
            'Genbun (1736â€“1741)',
            'KanpÅ (1741â€“1744)',
            'EnkyÅ (1744â€“1748)',
            'Kanâ€™en (1748â€“1751)',
            'HÅreki (1751â€“1764)',
            'Meiwa (1764â€“1772)',
            'Anâ€™ei (1772â€“1781)',
            'Tenmei (1781â€“1789)',
            'Kansei (1789â€“1801)',
            'KyÅwa (1801â€“1804)',
            'Bunka (1804â€“1818)',
            'Bunsei (1818â€“1830)',
            'TenpÅ (1830â€“1844)',
            'KÅka (1844â€“1848)',
            'Kaei (1848â€“1854)',
            'Ansei (1854â€“1860)',
            'Manâ€™en (1860â€“1861)',
            'BunkyÅ« (1861â€“1864)',
            'Genji (1864â€“1865)',
            'KeiÅ (1865â€“1868)',
            'Meiji',
            'TaishÅ',
            'ShÅwa',
            'Heisei',
          ],
          long: [
            'Taika (645â€“650)',
            'Hakuchi (650â€“671)',
            'HakuhÅ (672â€“686)',
            'ShuchÅ (686â€“701)',
            'TaihÅ (701â€“704)',
            'Keiun (704â€“708)',
            'WadÅ (708â€“715)',
            'Reiki (715â€“717)',
            'YÅrÅ (717â€“724)',
            'Jinki (724â€“729)',
            'TenpyÅ (729â€“749)',
            'TenpyÅ-kampÅ (749-749)',
            'TenpyÅ-shÅhÅ (749-757)',
            'TenpyÅ-hÅji (757-765)',
            'TenpyÅ-jingo (765-767)',
            'Jingo-keiun (767-770)',
            'HÅki (770â€“780)',
            'Ten-Å (781-782)',
            'Enryaku (782â€“806)',
            'DaidÅ (806â€“810)',
            'KÅnin (810â€“824)',
            'TenchÅ (824â€“834)',
            'JÅwa (834â€“848)',
            'KajÅ (848â€“851)',
            'Ninju (851â€“854)',
            'SaikÅ (854â€“857)',
            'Ten-an (857-859)',
            'JÅgan (859â€“877)',
            'GangyÅ (877â€“885)',
            'Ninna (885â€“889)',
            'KanpyÅ (889â€“898)',
            'ShÅtai (898â€“901)',
            'Engi (901â€“923)',
            'EnchÅ (923â€“931)',
            'JÅhei (931â€“938)',
            'TengyÅ (938â€“947)',
            'Tenryaku (947â€“957)',
            'Tentoku (957â€“961)',
            'ÅŒwa (961â€“964)',
            'KÅhÅ (964â€“968)',
            'Anna (968â€“970)',
            'Tenroku (970â€“973)',
            'Tenâ€™en (973â€“976)',
            'JÅgen (976â€“978)',
            'Tengen (978â€“983)',
            'Eikan (983â€“985)',
            'Kanna (985â€“987)',
            'Eien (987â€“989)',
            'Eiso (989â€“990)',
            'ShÅryaku (990â€“995)',
            'ChÅtoku (995â€“999)',
            'ChÅhÅ (999â€“1004)',
            'KankÅ (1004â€“1012)',
            'ChÅwa (1012â€“1017)',
            'Kannin (1017â€“1021)',
            'Jian (1021â€“1024)',
            'Manju (1024â€“1028)',
            'ChÅgen (1028â€“1037)',
            'ChÅryaku (1037â€“1040)',
            'ChÅkyÅ« (1040â€“1044)',
            'Kantoku (1044â€“1046)',
            'EishÅ (1046â€“1053)',
            'Tengi (1053â€“1058)',
            'KÅhei (1058â€“1065)',
            'Jiryaku (1065â€“1069)',
            'EnkyÅ« (1069â€“1074)',
            'ShÅho (1074â€“1077)',
            'ShÅryaku (1077â€“1081)',
            'EihÅ (1081â€“1084)',
            'ÅŒtoku (1084â€“1087)',
            'Kanji (1087â€“1094)',
            'KahÅ (1094â€“1096)',
            'EichÅ (1096â€“1097)',
            'JÅtoku (1097â€“1099)',
            'KÅwa (1099â€“1104)',
            'ChÅji (1104â€“1106)',
            'KashÅ (1106â€“1108)',
            'Tennin (1108â€“1110)',
            'Ten-ei (1110-1113)',
            'EikyÅ« (1113â€“1118)',
            'Genâ€™ei (1118â€“1120)',
            'HÅan (1120â€“1124)',
            'Tenji (1124â€“1126)',
            'Daiji (1126â€“1131)',
            'TenshÅ (1131â€“1132)',
            'ChÅshÅ (1132â€“1135)',
            'HÅen (1135â€“1141)',
            'Eiji (1141â€“1142)',
            'KÅji (1142â€“1144)',
            'Tenâ€™yÅ (1144â€“1145)',
            'KyÅ«an (1145â€“1151)',
            'Ninpei (1151â€“1154)',
            'KyÅ«ju (1154â€“1156)',
            'HÅgen (1156â€“1159)',
            'Heiji (1159â€“1160)',
            'Eiryaku (1160â€“1161)',
            'ÅŒho (1161â€“1163)',
            'ChÅkan (1163â€“1165)',
            'Eiman (1165â€“1166)',
            'Ninâ€™an (1166â€“1169)',
            'KaÅ (1169â€“1171)',
            'ShÅan (1171â€“1175)',
            'Angen (1175â€“1177)',
            'JishÅ (1177â€“1181)',
            'YÅwa (1181â€“1182)',
            'Juei (1182â€“1184)',
            'Genryaku (1184â€“1185)',
            'Bunji (1185â€“1190)',
            'KenkyÅ« (1190â€“1199)',
            'ShÅji (1199â€“1201)',
            'Kennin (1201â€“1204)',
            'GenkyÅ« (1204â€“1206)',
            'Kenâ€™ei (1206â€“1207)',
            'JÅgen (1207â€“1211)',
            'Kenryaku (1211â€“1213)',
            'KenpÅ (1213â€“1219)',
            'JÅkyÅ« (1219â€“1222)',
            'JÅÅ (1222â€“1224)',
            'Gennin (1224â€“1225)',
            'Karoku (1225â€“1227)',
            'Antei (1227â€“1229)',
            'Kanki (1229â€“1232)',
            'JÅei (1232â€“1233)',
            'Tenpuku (1233â€“1234)',
            'Bunryaku (1234â€“1235)',
            'Katei (1235â€“1238)',
            'Ryakunin (1238â€“1239)',
            'Enâ€™Å (1239â€“1240)',
            'Ninji (1240â€“1243)',
            'Kangen (1243â€“1247)',
            'HÅji (1247â€“1249)',
            'KenchÅ (1249â€“1256)',
            'KÅgen (1256â€“1257)',
            'ShÅka (1257â€“1259)',
            'ShÅgen (1259â€“1260)',
            'Bunâ€™Å (1260â€“1261)',
            'KÅchÅ (1261â€“1264)',
            'Bunâ€™ei (1264â€“1275)',
            'Kenji (1275â€“1278)',
            'KÅan (1278â€“1288)',
            'ShÅÅ (1288â€“1293)',
            'Einin (1293â€“1299)',
            'ShÅan (1299â€“1302)',
            'Kengen (1302â€“1303)',
            'Kagen (1303â€“1306)',
            'Tokuji (1306â€“1308)',
            'EnkyÅ (1308â€“1311)',
            'ÅŒchÅ (1311â€“1312)',
            'ShÅwa (1312â€“1317)',
            'BunpÅ (1317â€“1319)',
            'GenÅ (1319â€“1321)',
            'GenkÅ (1321â€“1324)',
            'ShÅchÅ« (1324â€“1326)',
            'Karyaku (1326â€“1329)',
            'Gentoku (1329â€“1331)',
            'GenkÅ (1331â€“1334)',
            'Kenmu (1334â€“1336)',
            'Engen (1336â€“1340)',
            'KÅkoku (1340â€“1346)',
            'ShÅhei (1346â€“1370)',
            'Kentoku (1370â€“1372)',
            'BunchÅ« (1372â€“1375)',
            'Tenju (1375â€“1379)',
            'KÅryaku (1379â€“1381)',
            'KÅwa (1381â€“1384)',
            'GenchÅ« (1384â€“1392)',
            'Meitoku (1384â€“1387)',
            'Kakei (1387â€“1389)',
            'KÅÅ (1389â€“1390)',
            'Meitoku (1390â€“1394)',
            'ÅŒei (1394â€“1428)',
            'ShÅchÅ (1428â€“1429)',
            'EikyÅ (1429â€“1441)',
            'Kakitsu (1441â€“1444)',
            'Bunâ€™an (1444â€“1449)',
            'HÅtoku (1449â€“1452)',
            'KyÅtoku (1452â€“1455)',
            'KÅshÅ (1455â€“1457)',
            'ChÅroku (1457â€“1460)',
            'KanshÅ (1460â€“1466)',
            'BunshÅ (1466â€“1467)',
            'ÅŒnin (1467â€“1469)',
            'Bunmei (1469â€“1487)',
            'ChÅkyÅ (1487â€“1489)',
            'Entoku (1489â€“1492)',
            'MeiÅ (1492â€“1501)',
            'Bunki (1501â€“1504)',
            'EishÅ (1504â€“1521)',
            'Taiei (1521â€“1528)',
            'KyÅroku (1528â€“1532)',
            'Tenbun (1532â€“1555)',
            'KÅji (1555â€“1558)',
            'Eiroku (1558â€“1570)',
            'Genki (1570â€“1573)',
            'TenshÅ (1573â€“1592)',
            'Bunroku (1592â€“1596)',
            'KeichÅ (1596â€“1615)',
            'Genna (1615â€“1624)',
            'Kanâ€™ei (1624â€“1644)',
            'ShÅho (1644â€“1648)',
            'Keian (1648â€“1652)',
            'JÅÅ (1652â€“1655)',
            'Meireki (1655â€“1658)',
            'Manji (1658â€“1661)',
            'Kanbun (1661â€“1673)',
            'EnpÅ (1673â€“1681)',
            'Tenna (1681â€“1684)',
            'JÅkyÅ (1684â€“1688)',
            'Genroku (1688â€“1704)',
            'HÅei (1704â€“1711)',
            'ShÅtoku (1711â€“1716)',
            'KyÅhÅ (1716â€“1736)',
            'Genbun (1736â€“1741)',
            'KanpÅ (1741â€“1744)',
            'EnkyÅ (1744â€“1748)',
            'Kanâ€™en (1748â€“1751)',
            'HÅreki (1751â€“1764)',
            'Meiwa (1764â€“1772)',
            'Anâ€™ei (1772â€“1781)',
            'Tenmei (1781â€“1789)',
            'Kansei (1789â€“1801)',
            'KyÅwa (1801â€“1804)',
            'Bunka (1804â€“1818)',
            'Bunsei (1818â€“1830)',
            'TenpÅ (1830â€“1844)',
            'KÅka (1844â€“1848)',
            'Kaei (1848â€“1854)',
            'Ansei (1854â€“1860)',
            'Manâ€™en (1860â€“1861)',
            'BunkyÅ« (1861â€“1864)',
            'Genji (1864â€“1865)',
            'KeiÅ (1865â€“1868)',
            'Meiji',
            'TaishÅ',
            'ShÅwa',
            'Heisei',
          ],
        },
        dayPeriods: { am: 'AM', pm: 'PM' },
      },
      persian: {
        months: {
          narrow: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
          ],
          short: [
            'Farvardin',
            'Ordibehesht',
            'Khordad',
            'Tir',
            'Mordad',
            'Shahrivar',
            'Mehr',
            'Aban',
            'Azar',
            'Dey',
            'Bahman',
            'Esfand',
          ],
          long: [
            'Farvardin',
            'Ordibehesht',
            'Khordad',
            'Tir',
            'Mordad',
            'Shahrivar',
            'Mehr',
            'Aban',
            'Azar',
            'Dey',
            'Bahman',
            'Esfand',
          ],
        },
        days: {
          narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
          short: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
          long: [
            'dimanche',
            'lundi',
            'mardi',
            'mercredi',
            'jeudi',
            'vendredi',
            'samedi',
          ],
        },
        eras: { narrow: ['AP'], short: ['AP'], long: ['AP'] },
        dayPeriods: { am: 'AM', pm: 'PM' },
      },
      roc: {
        months: {
          narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
          short: [
            'janv.',
            'fÃ©vr.',
            'mars',
            'avr.',
            'mai',
            'juin',
            'juil.',
            'aoÃ»t',
            'sept.',
            'oct.',
            'nov.',
            'dÃ©c.',
          ],
          long: [
            'janvier',
            'fÃ©vrier',
            'mars',
            'avril',
            'mai',
            'juin',
            'juillet',
            'aoÃ»t',
            'septembre',
            'octobre',
            'novembre',
            'dÃ©cembre',
          ],
        },
        days: {
          narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
          short: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
          long: [
            'dimanche',
            'lundi',
            'mardi',
            'mercredi',
            'jeudi',
            'vendredi',
            'samedi',
          ],
        },
        eras: {
          narrow: ['avant RdC', 'RdC'],
          short: ['avant RdC', 'RdC'],
          long: ['avant RdC', 'RdC'],
        },
        dayPeriods: { am: 'AM', pm: 'PM' },
      },
    },
  },
  number: {
    nu: ['latn'],
    patterns: {
      decimal: {
        positivePattern: '{number}',
        negativePattern: '{minusSign}{number}',
      },
      currency: {
        positivePattern: '{number}Â {currency}',
        negativePattern: '{minusSign}{number}Â {currency}',
      },
      percent: {
        positivePattern: '{number}Â {percentSign}',
        negativePattern: '{minusSign}{number}Â {percentSign}',
      },
    },
    symbols: {
      latn: {
        decimal: ',',
        group: 'Â ',
        nan: 'NaN',
        plusSign: '+',
        minusSign: '-',
        percentSign: '%',
        infinity: 'âˆž',
      },
    },
    currencies: {
      ARS: '$AR',
      AUD: '$AU',
      BEF: 'FB',
      BMD: '$BM',
      BND: '$BN',
      BRL: 'R$',
      BSD: '$BS',
      BZD: '$BZ',
      CAD: '$CA',
      CLP: '$CL',
      COP: '$CO',
      CYP: 'Â£CY',
      EUR: 'â‚¬',
      FJD: '$FJ',
      FKP: 'Â£FK',
      FRF: 'F',
      GBP: 'Â£GB',
      GIP: 'Â£GI',
      IEP: 'Â£IE',
      ILP: 'Â£IL',
      ILS: 'â‚ª',
      INR: 'â‚¹',
      ITL: 'â‚¤IT',
      KRW: 'â‚©',
      LBP: 'Â£LB',
      MTP: 'Â£MT',
      MXN: '$MX',
      NAD: '$NA',
      NZD: '$NZ',
      RHD: '$RH',
      SBD: '$SB',
      SGD: '$SG',
      SRD: '$SR',
      TTD: '$TT',
      USD: '$US',
      UYU: '$UY',
      VND: 'â‚«',
      WST: 'WS$',
      XAF: 'FCFA',
      XOF: 'CFA',
      XPF: 'FCFP',
    },
  },
})
